module.exports = __webpack_public_path__ + "static/media/social-link.a0ad625f.png";